// extracted by mini-css-extract-plugin
export default {"Wrap":"CollapsibleBody_Wrap__lwF2x","WrapOpen":"CollapsibleBody_WrapOpen__bAjeY","Clip":"CollapsibleBody_Clip__4zYQF"};